<div class="soft-overline mt-4">{{ '#ESL_LINK.ASSOCIATE_ITEMS.ITEMS' | translate }}</div>
<div class="soft-card rounded">
  <ul class="soft-list">
    @for (item of items(); track item) {
      <li class="soft-list-item">
        <div class="flex flex-row justify-between">
          <span>{{ item.cartikelnummer }} - {{ item.artbez1 }}</span>
          <soft-icon
            name="fa-regular fa-trash"
            class="cursor-pointer p-2 rounded-md hover:bg-hover"
            (click)="removeItem.emit(item)"
          ></soft-icon>
        </div>
      </li>
    }
    @if (items()?.length === 0) {
      <li>
        <span class="color-light">{{
          '#ESL_LINK.ASSOCIATE_ITEMS.NO_ITEMS' | translate
        }}</span>
      </li>
    }
  </ul>
</div>

<div class="action-header mt-5 color-light font-medium">
  {{ '#ESL_LINK.ASSOCIATE_ITEMS.MANUAL_INPUT' | translate }}
</div>

<soft-field-ok
  fieldOkName="artstamm"
  [placeholder]="'#ESL_LINK.ASSOCIATE_ITEMS.PLACEHOLDER'"
  [parameters]="{ kzgelistetall: false, sortierung: 2 }"
  #item
  >
</soft-field-ok>
<button
  class="soft-button primary w-full mt-2 min-height-button rounded"
  [disabled]="!item.value()"
  (click)="addItem.emit(item.value()); item.value.set(undefined)"
  >
  <span class="pt-1">{{ '#ESL_LINK.ASSOCIATE_ITEMS.ADD' | translate }}</span>
</button>

<div class="action-header uppercase mt-4 color-light font-medium">
  {{ '#ESL_LINK.ASSOCIATE_ITEMS.OR' | translate }}
</div>
<div
  class="soft-card rounded border-primary flex flex-row flex-nowrap pb-4 pt-4 pr-4 pl-4 center-v mb-1 cursor-pointer"
  (click)="startScan.emit()"
  >
  <i class="fa-regular fa-barcode-scan fa-3x mr-2 ml-1"></i>
  <div class="flex flex-col justify-center ml-3">
    <span class="text-bold">{{
      '#ESL_LINK.ASSOCIATE_ITEMS.SCAN_HEADER' | translate
    }}</span>
    <span class="color-light">
      {{ '#ESL_LINK.ASSOCIATE_ITEMS.SCAN_DESCRIPTION' | translate }}
    </span>
  </div>
</div>

@if (!itemCount()) {
  <div class="clear-fix"></div>
  <div class="submit-button">
    <button class="soft-button primary full" (click)="onSubmit.emit()" [disabled]="!item">
      {{ '#ESL_LINK.ASSOCIATE_ITEMS.SUBMIT' | translate }}
    </button>
  </div>
}
